export class FieldDef {
    public ApprovalExtension: boolean;
    public AutoSizeWidth: boolean;
    public Briefable: boolean;
    public CentralDB: boolean;
    public DefaultCaption: string;
    public ExtractTarget: boolean;
    public FieldGroup: string;
    public ID: string;
    public Just: string;
    public List: string;
    public MOSSend: boolean;
    public MOSTag: string;
    public MaxLength: number;
    public MaxVal: number;
    public Merge: boolean;
    public MinVal: number;
    public Parent: string;
    public ProtectedValue: boolean;
    public Publish: boolean;
    public ReadOnlyValue: boolean;
    public AssignmentProp: boolean;
    public TopicProp: boolean;
    public WireProp: boolean;
    public Required: boolean;
    public Sequence: number;
    public SetLock: boolean;
    public Statistics: boolean;
    public StoryboardProp: boolean;
    public Type: string;
    public Upper: boolean;
    public Validation: string;
    public VisibilityCriteria: string;
    public Width: number;
    public WordWrap: boolean;
    public DefaultValue: string;
    public DoNotCopy: boolean;
    public CopyToChild: boolean;
    public GroupableProp: boolean;
    public SortableProp: boolean;
    public SourceProp: boolean;
    public DraftProp: boolean;
    public PublicationProp: boolean;
    public PublicationListProp: boolean;
    public PublicationChannelProp: boolean;
    public ComplexPropInnerId: string;
    public ReadOnlyCriteria: string;
}

export class rssWireObject {
    public rssWireId: string;
    public title: string;
    public link: string;
    public description: string;
    public imgLinks: Array<string>;
}

export class apWireObject {
    public apWireId: string;
    public apId: string;
    public type: string;
    public priority: number;
    public rights: string;
    public extendedHeadline: string;
    public headline: string;
    public slugline: string;
    public keywords: string;
    public signals: string;
    public nitfLink: string;
    public mainLink: string;
    public previewLink: string;
    public thumbnailLink: string;
    public categoryCode: string;
    public city: string;
    public country: string;
    public countryName: string;
    public countryArea: string;
    public countryAreaName: string;
    public publishingStatus: string;
}

export class twitterWireObject {
    public twitterWireId: string;
    public name: string;
    public link: Array<string>;
    public userName: string;
    public text: string;
    public tweetId: string;
}
